// src/app/_components/edit-tags/edit-tags.component.ts
//
// "My private tags" page (/edit-tags): the current user's own PRIVATE tags only. A Space's tags are
// managed inside that Space (Space admin → Space tags). Both use the shared <app-tag-manager>.

import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TagManagerComponent } from '../tag-manager/tag-manager.component';

@Component({
  selector: 'app-edit-tags',
  standalone: true,
  imports: [RouterModule, TagManagerComponent],
  template: `
    <div class="mx-auto max-w-5xl px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(0.75rem,env(safe-area-inset-top))] text-(--p-text-color) sm:px-6 sm:pt-6">
      <header class="flex items-start gap-2 sm:gap-3">
        <a
          routerLink="/manage"
          class="-ml-2 inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-primary"
          aria-label="Back to Manage"
          title="Back to Manage">
          <i class="pi pi-arrow-left !text-xl" aria-hidden="true"></i>
        </a>
        <div class="min-w-0 flex-1">
          <h1 class="flex items-center gap-2 text-2xl font-semibold tracking-tight">
            <i class="pi pi-lock !text-xl text-(--p-text-muted-color)" aria-hidden="true"></i>
            My private tags
          </h1>
          <p class="mt-0.5 text-sm text-(--p-text-muted-color)">
            Tags only you can see, for any note you can open. Tags shared with a Space are managed in that
            Space's settings (Manage → Manage Spaces).
          </p>
        </div>
      </header>
      <section class="mt-4" aria-label="My private tags">
        <app-tag-manager />
      </section>
    </div>
  `,
})
export class EditTagsComponent {}
